import { Box } from "@mui/material";
import { styled } from "@mui/system";

const StyledWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  position: "relative",
  padding: "80px 0 100px",
  overflow: "hidden",
  backgroundColor: "#fff",
  [theme.breakpoints.down("md")]: {
    padding: "60px 0 80px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "40px 0 60px",
  },

  ".about-content-holder": {
    position: "relative",
    zIndex: 1,
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
    columnGap: "60px",
    alignItems: "start",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
      rowGap: "40px",
    },
  },

  ".about-text": {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    [theme.breakpoints.down("md")]: {
      gap: "20px",
    },
  },

  ".about-title-box": {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },

  ".about-description": {
    textAlign: "left !important" as "left",
    color: theme.palette.common.black,
    maxWidth: "none !important" as "none",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left !important" as "left",
    },
  },

  ".about-photo-wrap": {
    width: "100%",
    aspectRatio: "701 / 722",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      maxWidth: "500px",
      margin: "0 auto",
    },
  },

  ".about-photo": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
}));

export default StyledWrapper;
